'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _glamor = require('@headspace/glamor');

var _dasherize = require('dasherize');

var _dasherize2 = _interopRequireDefault(_dasherize);

var _breakpoints = require('./breakpoints');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var exportable = {
  flex: (0, _glamor.css)({
    display: 'flex'
  }),
  inlineFlex: (0, _glamor.css)({
    display: 'inline-flex'
  }),
  column: (0, _glamor.css)({
    flexDirection: 'column'
  }),
  columnReverse: (0, _glamor.css)({
    flexDirection: 'column-reverse'
  }),
  row: (0, _glamor.css)({
    flexDirection: 'row'
  }),
  rowReverse: (0, _glamor.css)({
    flexDirection: 'row-reverse'
  }),
  colSmallReflow: (0, _glamor.css)(_defineProperty({
    flexDirection: 'column'
  }, _breakpoints.minWidths.s, {
    flexDirection: 'row'
  })),
  colMediumReflow: (0, _glamor.css)(_defineProperty({
    flexDirection: 'column'
  }, _breakpoints.minWidths.m, {
    flexDirection: 'row'
  })),
  rowSmallReflow: (0, _glamor.css)(_defineProperty({
    flexDirection: 'row'
  }, _breakpoints.minWidths.s, {
    flexDirection: 'column'
  })),
  rowMediumReflow: (0, _glamor.css)(_defineProperty({
    flexDirection: 'row'
  }, _breakpoints.minWidths.m, {
    flexDirection: 'column'
  }))
};
'0,1,2,3,4,5,6,7,8,9,10'.split(',').forEach(function (x) {
  exportable['flex' + x] = (0, _glamor.css)({
    flex: x + ' 0 auto'
  });
});
'Center,FlexStart,FlexEnd,Initial'.split(',').forEach(function (x) {
  exportable['alignItems' + x] = (0, _glamor.css)({
    alignItems: (0, _dasherize2.default)(x)
  });
  exportable['justifyContent' + x] = (0, _glamor.css)({
    justifyContent: (0, _dasherize2.default)(x)
  });
});
exportable['justifyContentSpaceBetween'] = (0, _glamor.css)({
  justifyContent: 'space-between'
});
exportable['justifyContentAround'] = (0, _glamor.css)({
  justifyContent: 'space-around'
});
'Wrap,Nowrap,WrapReverse'.split(',').forEach(function (x) {
  exportable['flexWrap' + x] = (0, _glamor.css)({
    flexWrap: (0, _dasherize2.default)(x)
  });
});
'0,1,Auto,100%,50%'.split(',').forEach(function (x) {
  exportable['flexBasis' + x.replace('%', 'Percent')] = (0, _glamor.css)({
    '@media screen': {
      // hack to overide grid
      flexBasis: x.toLowerCase()
    }
  });
});
'0,1'.split(',').forEach(function (x) {
  exportable['flexShrink' + x] = (0, _glamor.css)({
    '@media screen': {
      // hack to overide grid
      flexShrink: x
    }
  });
  exportable['flexGrow' + x] = (0, _glamor.css)({
    '@media screen': {
      // hack to overide grid
      flexGrow: x
    }
  });
});
exportable.flexBasisFull = (0, _glamor.css)({
  '@media screen': {
    // hack to overide grid
    flexBasis: '100%'
  }
});
'0,1,Auto'.split(',').forEach(function (x) {
  exportable['flexShrink' + x] = (0, _glamor.css)({
    '@media screen': {
      // hack to overide grid
      flexShrink: x.toLowerCase()
    }
  });
});
exportable.flexBasisSafariWrap = (0, _glamor.css)({
  '@media screen': {
    // hack to overide grid
    flexBasis: '15em'
  }
});
exports.default = exportable;